import i18n from '@/i18n/index';

export const required = v => !!v || i18n.t("common.required"); //'is required'
export const minLength = number => v => (v || '').length >= number || `Debe tener más de ${number} caracteres`;
export const maxLength = number => v => (v || '').length <= number || `Debe tener menos de ${number} caracteres`;
export const email = v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'No es un e-mail válido';
export const number = v => /^[0-9]*$/.test(v) || 'No es un usuario válido';
export const numberLessOrEqualThan = number => v => (v) <= number || `Debe ser menor o igual que ${number}`;
